/** Original Blender-built system places, served through the finalized model catalog.
 * Coordinates and conservative collision boxes use the public model contract.
 * GLBs are deliberately not bundled: publish the exact content-addressed assets first.
 */
import {PATCH_CONTRACT} from './world-contract.mjs';
export const CONNECTED_PLACES_VERSION=3;
export const SUNSET_COURT_ASSET_ID='asset_1f1550f7b3ca35b20820847df8cad36384723cb0b6d93c43ca7fcfc5c244155e';
const SUNSET_COURT_COLLIDERS=[
 [-31.5,0.65,-5.5,0.55,1.3,64],
 [31.5,0.65,-5.5,0.55,1.3,64],
 [0,0.65,-37.5,63,1.3,0.55],
 [0,0.65,26.5,63,1.3,0.55],
 [-11,0.63,-3.5,0.18,1.26,0.18],
 [11,0.63,-3.5,0.18,1.26,0.18],
 [0,0.56,-3.5,22,0.95,0.08],
 [-19,1.8,-24,0.7,3.6,1.1],
 [-11.4,1.8,-24,0.7,3.6,1.1],
 [-3.8,1.8,-24,0.7,3.6,1.1],
 [3.8,1.8,-24,0.7,3.6,1.1],
 [11.4,1.8,-24,0.7,3.6,1.1],
 [19,1.8,-24,0.7,3.6,1.1],
 [0,3.7,-33,39,7.4,0.5],
 [-19.3,3.7,-28.5,0.5,7.4,9],
 [19.3,3.7,-28.5,0.5,7.4,9],
 [0,7.55,-28.5,40,0.35,10.8],
 [-14,0.58,-29,2.45,1.16,0.7],
 [14,0.58,-29,2.45,1.16,0.7],
 [-23.5,1.7,-13,0.28,3.4,0.28],
 [-23.5,1.7,0,0.28,3.4,0.28],
 [-23.5,1.7,10,0.28,3.4,0.28],
 [-17.5,1.7,-13,0.28,3.4,0.28],
 [-17.5,1.7,0,0.28,3.4,0.28],
 [-17.5,1.7,10,0.28,3.4,0.28],
 [-20.5,0.58,-9,2.45,1.16,0.7],
 [-20.5,0.3,-10.9,5.2,0.6,1.2],
 [-20.5,0.58,3,2.45,1.16,0.7],
 [-20.5,0.3,1.1,5.2,0.6,1.2],
 [-20.5,3.6,-18,0.6,7.2,0.6],
 [-20.5,0.32,-18,2.5,0.64,2.5],
 [-20.5,3.6,15,0.6,7.2,0.6],
 [-20.5,0.32,15,2.5,0.64,2.5],
 [-13.8,2.4,-18,0.45,5.6,0.45],
 [-13.8,2.4,11,0.45,5.6,0.45],
 [-15,0.56,6,1,1.12,0.65],
 [17.5,1.7,-13,0.28,3.4,0.28],
 [17.5,1.7,0,0.28,3.4,0.28],
 [17.5,1.7,10,0.28,3.4,0.28],
 [23.5,1.7,-13,0.28,3.4,0.28],
 [23.5,1.7,0,0.28,3.4,0.28],
 [23.5,1.7,10,0.28,3.4,0.28],
 [20.5,0.58,-9,2.45,1.16,0.7],
 [20.5,0.3,-10.9,5.2,0.6,1.2],
 [20.5,0.58,3,2.45,1.16,0.7],
 [20.5,0.3,1.1,5.2,0.6,1.2],
 [20.5,3.6,-18,0.6,7.2,0.6],
 [20.5,0.32,-18,2.5,0.64,2.5],
 [20.5,3.6,15,0.6,7.2,0.6],
 [20.5,0.32,15,2.5,0.64,2.5],
 [13.8,2.4,-18,0.45,5.6,0.45],
 [13.8,2.4,11,0.45,5.6,0.45],
 [15,0.56,6,1,1.12,0.65],
 [-8,0.6,13,0.18,1.2,0.18],
 [-8,1.4,13,2.5,1.8,0.3],
 [8,0.6,13,0.18,1.2,0.18],
 [8,1.4,13,2.5,1.8,0.3],
 [-25.5,0.3,21,7,0.6,2],
 [25.5,0.3,21,7,0.6,2],
 [0,8.75,-30,5,2.2,4.5],
 [0,9.94,-30,5.4,0.22,4.9],
];
const SUNSET_COURT_ATMOSPHERE={"skyColor":"#92768b","horizonColor":"#efbea0","groundColor":"#ad999d","stars":false,"retroSun":false,"wireLandscape":false,"fogNear":85,"fogFar":190,"ambientIntensity":1.7,"sunIntensity":2.1};
export const NIGHT_LINE_ASSET_ID='asset_e78f23a35e4ad8be314aed9f711d4b416a1b04a74365e02666c298db762df3c8';
const NIGHT_LINE_COLLIDERS=[
 [-31.5,0.65,-5.5,0.55,1.3,64],
 [31.5,0.65,-5.5,0.55,1.3,64],
 [0,0.65,-37.5,63,1.3,0.55],
 [0,0.65,26.5,63,1.3,0.55],
 [0,0.18,-11,12,0.36,36],
 [0,0.075,7.9,12,0.15,1.8],
 [0,0.15,6.7,12,0.3,0.8],
 [-10,2.3,-13,3.5,3.4,24],
 [-5.7,2.31,3,0.21,3.9,0.21],
 [5.7,2.31,3,0.21,3.9,0.21],
 [-5.7,2.31,-3,0.21,3.9,0.21],
 [5.7,2.31,-3,0.21,3.9,0.21],
 [-5.7,2.31,-9,0.21,3.9,0.21],
 [5.7,2.31,-9,0.21,3.9,0.21],
 [-5.7,2.31,-15,0.21,3.9,0.21],
 [5.7,2.31,-15,0.21,3.9,0.21],
 [-5.7,2.31,-21,0.21,3.9,0.21],
 [5.7,2.31,-21,0.21,3.9,0.21],
 [-5.7,2.31,-27,0.21,3.9,0.21],
 [5.7,2.31,-27,0.21,3.9,0.21],
 [2.6,0.58,-6,2.45,1.16,0.7],
 [2.6,0.58,-19,2.45,1.16,0.7],
 [-4.2,3.1,-32,6.4,6.2,6],
 [4.2,3.1,-32,6.4,6.2,6],
 [0,6.5,-31,15,0.65,8],
 [-16,2.1,-26,0.45,5.0,0.45],
 [-16,2.1,-8,0.45,5.0,0.45],
 [-16,2.1,9,0.45,5.0,0.45],
 [-16,0.3,-17,2.1,0.6,4],
 [-16,0.3,2,2.1,0.6,4],
 [16,2.1,-26,0.45,5.0,0.45],
 [16,2.1,-8,0.45,5.0,0.45],
 [16,2.1,9,0.45,5.0,0.45],
 [16,0.3,-17,2.1,0.6,4],
 [16,0.3,2,2.1,0.6,4],
 [-25,7.0,-26,10,14,14],
 [25,8.5,-26,10,17,14],
 [-26,5.0,-6,8,10,10],
 [26,6.0,-6,8,12,10],
 [-5,1.35,14,0.3,2.7,0.5],
 [5,1.35,14,0.3,2.7,0.5],
 [-6.19125,4.204654709449793,-12,0.3174999999999999,0.33989084449791906,30.6],
 [-5.873749999999999,4.418907327165713,-12,0.3174999999999999,0.3286143909339224,30.6],
 [-5.55625,4.621883491317638,-12,0.3174999999999999,0.31733793736992755,30.6],
 [-5.23875,4.813583201905567,-12,0.3174999999999999,0.3060614838059309,30.6],
 [-4.921250000000001,4.9940064589295,-12,0.3174999999999999,0.29478503024193514,30.6],
 [-4.60375,5.1631532623894385,-12,0.3174999999999999,0.2835085766779394,30.6],
 [-4.286250000000001,5.32102361228538,-12,0.3174999999999999,0.2722321231139436,30.6],
 [-3.9687499999999996,5.467617508617326,-12,0.3174999999999999,0.26095566954994787,30.6],
 [-3.6512499999999997,5.602934951385276,-12,0.3174999999999999,0.2496792159859521,30.6],
 [-3.3337499999999998,5.72697594058923,-12,0.3174999999999999,0.23840276242195635,30.6],
 [-3.01625,5.8397404762291885,-12,0.3174999999999999,0.2271263088579606,30.6],
 [-2.69875,5.941228558305151,-12,0.3174999999999999,0.21584985529396483,30.6],
 [-2.38125,6.031440186817118,-12,0.3174999999999999,0.20457340172996819,30.6],
 [-2.06375,6.110375361765088,-12,0.3174999999999999,0.19329694816597331,30.6],
 [-1.7462500000000003,6.178034083149063,-12,0.3174999999999999,0.18202049460197667,30.6],
 [-1.4287499999999995,6.234416350969043,-12,0.3174999999999999,0.1707440410379818,30.6],
 [-1.1112499999999996,6.279522165225027,-12,0.3175,0.15946758747398515,30.6],
 [-0.7937500000000006,6.313351525917014,-12,0.3175,0.1481911339099894,30.6],
 [-0.4762499999999998,6.335904433045005,-12,0.3175,0.13691468034599452,30.6],
 [-0.1587499999999999,6.347180886609001,-12,0.3175,0.125638226781997,30.6],
 [0.15875,6.347180886609001,-12,0.3175,0.125638226781997,30.6],
 [0.4762499999999999,6.335904433045005,-12,0.3175,0.13691468034599452,30.6],
 [0.7937499999999997,6.313351525917014,-12,0.3175,0.1481911339099894,30.6],
 [1.1112499999999996,6.279522165225027,-12,0.3174999999999999,0.15946758747398515,30.6],
 [1.4287499999999995,6.234416350969043,-12,0.3174999999999999,0.1707440410379818,30.6],
 [1.7462500000000003,6.178034083149063,-12,0.3174999999999999,0.18202049460197667,30.6],
 [2.0637499999999993,6.110375361765088,-12,0.3174999999999999,0.19329694816597243,30.6],
 [2.38125,6.031440186817118,-12,0.3174999999999999,0.20457340172996819,30.6],
 [2.698749999999999,5.941228558305151,-12,0.3174999999999999,0.21584985529396483,30.6],
 [3.01625,5.8397404762291885,-12,0.3174999999999999,0.2271263088579606,30.6],
 [3.3337500000000007,5.72697594058923,-12,0.3174999999999999,0.23840276242195635,30.6],
 [3.6512499999999997,5.602934951385276,-12,0.3174999999999999,0.2496792159859521,30.6],
 [3.9687500000000004,5.467617508617326,-12,0.3174999999999999,0.26095566954994787,30.6],
 [4.286249999999999,5.32102361228538,-12,0.3174999999999999,0.2722321231139436,30.6],
 [4.603749999999998,5.1631532623894385,-12,0.3174999999999999,0.2835085766779394,30.6],
 [4.921250000000001,4.9940064589295,-12,0.3174999999999999,0.29478503024193514,30.6],
 [5.23875,4.813583201905567,-12,0.3174999999999999,0.3060614838059309,30.6],
 [5.556249999999999,4.621883491317639,-12,0.3174999999999999,0.31733793736992755,30.6],
 [5.873749999999999,4.418907327165713,-12,0.3174999999999999,0.3286143909339224,30.6],
 [6.191249999999998,4.204654709449793,-12,0.3174999999999999,0.3398908444979182,30.6],
 [-10,3.99,-20,1.8,0.28,2.3],
 [-10,3.99,-6,1.8,0.28,2.3],
 [-25,14.2,-26,10.35,0.4,14.35],
 [25,17.2,-26,10.35,0.4,14.35],
 [-26,10.2,-6,8.35,0.4,10.35],
 [26,12.2,-6,8.35,0.4,10.35],
 [0,7.12,-31,7,0.65,6],
];
const NIGHT_LINE_ATMOSPHERE={"skyColor":"#192b45","horizonColor":"#697995","groundColor":"#3b455d","stars":true,"retroSun":false,"wireLandscape":false,"fogNear":65,"fogFar":155,"ambientIntensity":1.45,"sunIntensity":1.25};
function modelPatch(baseRevision,{id,name,description,assetId,colliders,atmosphere}) {
 return {contract:PATCH_CONTRACT,baseRevision,operations:[
  {op:'setWorld',values:{name,description,theme:id,gravity:18,atmosphere:{...atmosphere}}},
  {op:'putEntity',entity:{id:id+'-architecture',kind:'model',assetId,
   position:{x:0,y:0,z:0},scale:{x:1,y:1,z:1},rotation:{x:0,y:0,z:0},color:'#ffffff',capabilities:[],
   colliders:colliders.map(([x,y,z,sx,sy,sz])=>({center:{x,y,z},size:{x:sx,y:sy,z:sz}}))}}
 ]};
}
export function sunsetCourtPatch(baseRevision=1) {
 return modelPatch(baseRevision,{id:'sunset-court',name:'Sunset Court',
  description:'A quiet city court in the last light, framed by a clock-topped clubhouse and shaded benches.',
  assetId:SUNSET_COURT_ASSET_ID,colliders:SUNSET_COURT_COLLIDERS,atmosphere:SUNSET_COURT_ATMOSPHERE});
}
export function nightLinePatch(baseRevision=1) {
 return modelPatch(baseRevision,{id:'night-line',name:'Night Line',
  description:'The last train waits beneath a vaulted canopy. Wander the platform between warm lamps and the midnight skyline.',
  assetId:NIGHT_LINE_ASSET_ID,colliders:NIGHT_LINE_COLLIDERS,atmosphere:NIGHT_LINE_ATMOSPHERE});
}
